import { MetricUnit } from '@/__generated__/graphql';
import Echarts, { EChartsOptionBuilder } from '@features/echarts';
import { Trans } from '@lingui/macro';
import { Box, Typography } from '@mui/material';
import { type FC, useMemo } from 'react';

export type ChartPreviewSerie = {
  name: string;
  data: number[][];
  dataType: string;
  unit: MetricUnit;
};

interface Props {
  series: ChartPreviewSerie[];
}

export const ChartPreview: FC<Props> = ({ series }) => {
  const option = useMemo(() => {
    const option = new EChartsOptionBuilder({
      toolbox: {
        disabled: true,
      },
    });
    option.addXAxis({
      id: 'time',
      type: 'time',
    });

    const seriesUnits = Array.from(new Set(series.map((serie) => serie.unit)));

    for (const unit of seriesUnits) {
      option.addYAxis({
        id: unit,
        unit,
        type: 'value',
      });
    }

    option.addSeries(
      series.map((serie) => {
        return {
          meta: {
            name: serie.name,
            data: serie.data,
            dataType: serie.dataType,
            type: 'line',
            xAxisId: 'time',
            yAxisId: serie.unit,
          },
          value(value) {
            return {
              ...value,
              symbol: 'circle',
            };
          },
        };
      }),
    );

    return option;
  }, [series]);

  return (
    <Box height={300}>
      <Typography variant="h6">
        <Trans>Previsualización</Trans>
      </Typography>
      <Echarts option={option} renderer="canvas" />
    </Box>
  );
};
